import React, { useEffect, useState } from 'react';
// import 'antd/dist/antd.css';

import { Input, Radio, message, Spin, Modal, Button, Row, Col, Form } from 'antd';
import CKEditorUtil from '../../../../utils/ckEditorUtil'
import efn from './InviteInfoUpsertPageFns'
import moment from 'moment'

function InviteInfoUpsertPage(props) {
  const { lang, inviteInfoMap } = props
  const [form] = Form.useForm();
  const { TextArea } = Input
  const [langInviteInfo, setLangInviteInfo] = useState()
  const [editorData, setEditorData] = useState();
  let setFuncMap = { setLangInviteInfo, setEditorData, ...props.setFuncMap }
  const onFinish = values => {
    values["lang"] = lang
    values["content"] = editorData
    efn.updateInviteInfo(values, props, setFuncMap)
  };

  useEffect(() => {
    setLangInviteInfo(inviteInfoMap[lang])
    form.setFieldsValue(inviteInfoMap[lang])
  }, [inviteInfoMap])

  useEffect(() => {
    form.setFieldsValue(langInviteInfo)
  }, [langInviteInfo])

  return (
    <Form
      form={form}
      layout="horizontal"
      onFinish={onFinish}
    >
      <CKEditorUtil setFuncMap={setFuncMap} defaultValue={langInviteInfo ? langInviteInfo.content : null} />
      <Form.Item
        name="id"
        hidden
      >
        <Input type="hidden" />{langInviteInfo && langInviteInfo.lastUpdateAt && `最後更新時間: ${moment(langInviteInfo.lastUpdateAt).format("yyyy-MM-DD HH:mm:ss")}`}
      </Form.Item>
      <Row justify={"center"} gutter={16}>
        <Col>
          <Button type="primary" htmlType="submit">
            更新
          </Button>
        </Col>
      </Row>

    </Form>
  );
}



export default React.memo(InviteInfoUpsertPage);
